var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-image-component",class:{ blue: _vm.color === 'blue', yellow: _vm.color === 'yellow', right: _vm.align }},[_vm._t("img"),_c('div',{staticClass:"card-title title-2"},[_vm._v(_vm._s(_vm.title))]),_vm._t("body"),_c('div',{staticClass:"card-action"},[_vm._t("action")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }